export const CPP_EST_RECEIVED = 'CPP_EST_RECEIVED'
export const CPP_RESULT_RECEIVED = 'CPP_RESULT_RECEIVED'
export const CPP_EST_UNLOADED = 'CPP_EST_UNLOADED'
